import React from "react";
import myImage from "../../../src/assets/images/thank-you-logo.png";
import checkThank from "../../../src/assets/icons/check-thank.svg";
import puravankarLogo from "../../../src/assets/images/thank-you-logo.png";
// import ProvidentLogo from "../../../src/assets/images/Provident Reverse logo.png";
import ProvidentLogo from "../../../src/assets/icons/Provident.svg";

// import PurvaLandLogo from "../../../src/assets/images/PurvaLand Master Logo reverse.png";
import PurvaLandLogo from "../../../src/assets/icons/Purva Land 1.svg";

import "./FeedbackModal.scss";
import {Typography} from "@mui/material";
import { useSelector } from "react-redux";
import { COMPARE_VALUE } from "../../config/constant";
const {REACT_APP_BRANDLOGO_URL } = process.env
const ThankYouModal = () => {
  const { projectBrandImage, enquiryDetails } = useSelector(
    (state) => state?.customerForm
  );

  const getBrandImage = () => {
    if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Puravankara
    ) {
      return puravankarLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Provident
    ) {
      return ProvidentLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.PurvaLand
    ) {
      return PurvaLandLogo;
    }
  };

  return (
    <div style={{
      backgroundImage: `url("${REACT_APP_BRANDLOGO_URL + '/' + projectBrandImage}")`,
      }} className="modalCustomFeedback height100 applicantBackground">
      <div className="modalCustomFeedbackContent width642">
        {/* <span className="customClose">
          <HighlightOffIcon />
        </span> */}
        <div className="logoFeedback">
          <img src={getBrandImage()} alt="Logo" />
        </div>
        <div className="checkThank">
          <img src={checkThank} alt="" />
        </div>
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: "600",
            color: "#1C252E",
            mb: 1,
            textAlign: "center",
          }}
        >
          Thank you for your valuable feedback.
        </Typography>
      </div>
    </div>
  );
};

export default ThankYouModal;
